export enum QuickBooksProjectWarningTypeDTO {
  HAS_NO_QUICK_BOOKS_INTEGRATION = 'HAS_NO_QUICK_BOOKS_INTEGRATION',
  PROJECT_CURRENCY_MISMATCHES_QUICK_BOOKS = 'PROJECT_CURRENCY_MISMATCHES_QUICK_BOOKS',
}

export interface QuickBooksProjectWarningResponse {
  type: QuickBooksProjectWarningTypeDTO;
  args?: Record<string, unknown>;
}
